import { EMAIL_TYPES } from 'constants/logic';
import { CAMPAIGN_TYPE } from 'features/Campaigns/Campaigns.helpers';

export const EMAIL_MESSAGE_TYPE_BY_EMAIL_TYPE = {
  [EMAIL_TYPES.GENERIC]: 'Email class',
  [EMAIL_TYPES.GENERIC_TO_NEW_USERS]: 'Email new users',
  [EMAIL_TYPES.GENERIC_TO_SOME_USERS]: 'Email member',
};

export const SMARTSPOT_UPDATE_SOURCE = {
  SMART_TOOLS: 'smart tools',
  OPPORTUNITIES: 'opportunities',
};

export const OPPORTUNITY_ACT_SOURCE = {
  SCHEDULE: 'schedule',
  OPPORTUNITIES: 'opportunities',
};

export const CAMPAIGN_TYPE_TO_TRACKING_TYPE = {
  [CAMPAIGN_TYPE.ALL_USER]: 'all_users',
  [CAMPAIGN_TYPE.NEW_USER]: 'new_users',
  [CAMPAIGN_TYPE.WINBACK]: 'winback',
  [CAMPAIGN_TYPE.TIME_SLOT_ALL_USER]: 'time_based',
};

export const getCampaignTrackingType = type => CAMPAIGN_TYPE_TO_TRACKING_TYPE[type?.replace(/_(VENUE|CLASS)$/, '')];

export const CLASS_STATUS_CHANGE_SOURCE = {
  INDEX_PAGE: 'index page',
  CLASS_PAGE: 'class page',
};
